import Icons from "../../../../../shared/constants/icon.constant";
import ComingSoon from "../../../../../shared/components/ComingSoon";

const tradeRoutes = {
  path: "trade",
  label: "Trade",
  icon: Icons.Trade({ width: 16, height: 16 }),
  children: [
    {
      path: "overview",
      label: "Overview",
      icon: Icons.Overview({ width: 16, height: 16 }),
      element: <ComingSoon />,
      comingSoon: true,
    },
    {
      path: "trade",
      label: "Trade",
      icon: Icons.GlobalTrade({ width: 16, height: 16 }),
      element: <ComingSoon />,
      comingSoon: true,
    },
    {
      path: "future",
      label: "Future",
      icon: Icons.Future({ width: 16, height: 16 }),
      element: <ComingSoon />,
      comingSoon: true,
    },
    {
      path: "journal",
      label: "Journal",
      icon: Icons.Journal({ width: 16, height: 16 }),
      element: <ComingSoon />,
      comingSoon: true,
    },
  ],
};

export default tradeRoutes;
